import Cookie from '@nuxt-common/util/app/utils/cookie/Cookie.js';
import { getUserGuid } from '#utils/UserDetails';
import { getError, getErrorMessage } from '#utils/ErrorHandler';
import { processErrorDetails } from '#utils/errorArrayDetails';
import { defineStore } from 'pinia';
import $http from '@vue-util/http';

const WISHLIST_ENDPOINT = '/xapi/wishlist/v1/lists';

export const useUpdateListStore = defineStore('updateList', {
  state: () => ({
    updateListError: null,
    updateListErrorDetails: null,
    updateListLoadingState: false,
    updateListErrorStatus: false,
  }),
  actions: {
    async updateList({ payload, listGuid, headers }) {
      this.updateListLoadingState = true;
      this.updateListErrorStatus = false;
      this.updateListError = null;
      try {
        const response = await $http.put(`${WISHLIST_ENDPOINT}/${listGuid}?userGuid=${getUserGuid()}`, payload, {
          headers,
        });
        const responseData = response.data || response;
        if (getError(responseData)) {
          const errorObj = getError(responseData);
          const errorDetails = processErrorDetails(errorObj);
          this.updateListError = getErrorMessage(responseData, 'GENERIC');
          this.updateListErrorDetails = errorDetails;
        }
      } catch (error) {
        if (error.response?.status === 401) {
          Cookie.set('SignedIn', '0');
          this.updateListErrorStatus = true;
        }
        const data = error?.response?.data;
        const errorObj = getError(data);
        const errorDetails = processErrorDetails(errorObj);
        this.updateListError = getErrorMessage(error, 'BAD_REQUEST');
        this.updateListErrorDetails = errorDetails;
      } finally {
        this.updateListLoadingState = false;
      }
    },
    setUpdateListError(error) {
      this.updateListError = error;
    },
    setUpdateListErrorDetails(errorDetails) {
      this.updateListErrorDetails = errorDetails;
    },
    setUpdateListLoadingState(loadValue) {
      this.updateListLoadingState = loadValue;
    },
    setUpdateListErrorStatus(value) {
      this.updateListErrorStatus = value;
    },
  },
});
